import { formatTimestampToIST } from "./date-time";
import tzLookup from "tz-lookup";
import { toZonedTime, format } from "date-fns-tz";
export const formatDateWithCustomSeperator = ({
    input,
    separator,
}: {
    input: string;
    separator: string;
}) => {
    const [year, month, day] = input.split(separator).map(Number);
    const date = new Date(year, month - 1, day);

    return date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
};

export const timeAgo = (timestamp?: number) => {
    if (!timestamp || isNaN(timestamp)) return "";

    const now = new Date();
    const diffInSeconds = Math.floor((now.getTime() - timestamp) / 1000);
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);

    if (diffInWeeks > 0) {
        return formatTimestampToIST(timestamp); // Show the full timestamp if more than 7 days old
    } else if (diffInDays > 0) {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInHours > 0) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    } else if (diffInMinutes > 0) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    } else {
        return `${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
    }
};

export const usetimeAgo = (
    timestamp: number,
    currentTime: number = Date.now(),
) => {
    const now = new Date(currentTime);
    const diffInSeconds = Math.floor((now.getTime() - timestamp) / 1000);
    if (diffInSeconds < 0) return "0 second ago";
    const diffInMinutes = Math.floor(diffInSeconds / 60);
    const diffInHours = Math.floor(diffInMinutes / 60);
    const diffInDays = Math.floor(diffInHours / 24);
    const diffInWeeks = Math.floor(diffInDays / 7);

    if (diffInWeeks > 0) {
        return formatTimestampToIST(timestamp); // Show full timestamp if more than 7 days old
    } else if (diffInDays > 0) {
        return `${diffInDays} day${diffInDays > 1 ? "s" : ""} ago`;
    } else if (diffInHours > 0) {
        return `${diffInHours} hour${diffInHours > 1 ? "s" : ""} ago`;
    } else if (diffInMinutes > 0) {
        return `${diffInMinutes} minute${diffInMinutes > 1 ? "s" : ""} ago`;
    } else {
        return `${diffInSeconds} second${diffInSeconds > 1 ? "s" : ""} ago`;
    }
};

export const isPastLocal = (dateString: string): boolean => {
    const inputDateIST = new Date(dateString);
    const nowLocal = new Date();

    // Convert IST to user's local timezone
    const inputDateLocal = new Date(
        inputDateIST.getTime() + nowLocal.getTimezoneOffset() * 60 * 1000,
    );

    return inputDateLocal < nowLocal;
};

export function getLocalTime(lat: number, lng: number): string {
    if (!lat || !lng) return null;
    try {
        const timeZone = tzLookup(lat, lng);
        const now = new Date();
        const zonedTime = toZonedTime(now, timeZone);

        return format(zonedTime, "hh:mm a");
    } catch (error) {
        console.error("Error fetching local time:", error);
        return "Error fetching local time";
    }
}

export const addOneHour = (dateStr) => {
    if (!dateStr) {
        // Handle undefined/null/empty string case
        return undefined; // or return null, or throw an error
    }

    const originalDate = new Date(dateStr);

    // Check if the date is invalid (e.g., if dateStr was malformed)
    if (isNaN(originalDate.getTime())) {
        return undefined; // or handle the error as needed
    }

    // Add 1 hour (3600 seconds * 1000 milliseconds)
    const updatedDate = new Date(originalDate.getTime() + 60 * 60 * 1000);

    return updatedDate.toISOString();
};
